/* RF — Global fade-up reveal (diagnostic) */
(function () {
  function log(){ try{ console.log('[RF reveal]', ...arguments); }catch(e){} }

  function boot() {
    log('boot');
    document.body.classList.add('rf-reveal-on'); // tells CSS JS is alive

    const els = Array.from(document.querySelectorAll('.rf-fadeup'));
    log('found .rf-fadeup:', els.length, els);
    if (!els.length) return;

    // Reduced motion: show immediately
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(el => el.classList.add('is-in'));
      log('reduced-motion: revealed immediately');
      return;
    }

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
          log('IO', target, 'isIntersecting=', isIntersecting, 'ratio=', intersectionRatio);
          target.classList.toggle('is-in', isIntersecting);
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });

      els.forEach(el => {
        // el.style.outline = '2px solid rgba(255,200,0,.4)'; // uncomment to see targets
        io.observe(el);
      });
    } else {
      // Old-browser fallback
      function check() {
        els.forEach(el => {
          const r = el.getBoundingClientRect();
          const inView = r.top < innerHeight * 0.9 && r.bottom > 0;
          el.classList.toggle('is-in', inView);
        });
      }
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init in the theme editor
  document.addEventListener('shopify:section:load', boot);

  // Manual trigger for debugging
  window.RF_REVEAL_BOOT = boot;
})();
